var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.277 12.7384C16.3009 10.8893 17.2939 9.13964 18.8693 8.17113C17.8754 6.75178 16.2108 5.85187 14.479 5.79768C12.6318 5.6038 10.8411 6.90299 9.89979 6.90299C8.9403 6.90299 7.49105 5.81693 5.93044 5.84904C3.89627 5.91476 1.9999 7.07128 1.01023 8.8497C-1.11717 12.533 0.46968 17.9461 2.50755 20.9234C3.52714 22.3813 4.71875 24.0098 6.27795 23.952C7.80371 23.8887 8.37356 22.9791 10.2153 22.9791C12.0399 22.9791 12.5746 23.952 14.1654 23.9153C15.8026 23.8887 16.8341 22.4509 17.8179 20.9792C18.5505 19.9404 19.1142 18.7924 19.4882 17.5775C17.5642 16.7637 16.2793 14.8274 16.277 12.7384Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2722 3.83968C14.1649 2.76805 14.6047 1.39066 14.4982 0C13.1344 0.143243 11.8746 0.795057 10.9698 1.82557C10.0851 2.83244 9.62472 4.1856 9.71177 5.5231C11.0761 5.53715 12.4173 4.903 13.2722 3.83968Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d2a8290c9e4a9429763d0da8513af95c.svg";
export { ForwardRef as ReactComponent };